import React, { useRef } from 'react';
import { Box, Image, Input, Text, Button } from '@chakra-ui/react';

import logoImg from '../../../images/logo.png';

const ProfileImageUploader = ({
  profileImageUrl,
  alt,
  onImageChange,
  onRemoveImage,
  uploading,
  size = { base: '100px', md: '120px' },
}) => {
  const inputRef = useRef(null);

  const handleClick = () => {
    if (!uploading && inputRef.current) inputRef.current.click();
  };

  return (
    <Box>
      <Box
        position="relative"
        boxSize={size}
        flexShrink={0}
        cursor={uploading ? 'not-allowed' : 'pointer'}
        onClick={handleClick}
        _hover={
          !uploading
            ? {
                '& .overlay': { opacity: 1 },
              }
            : undefined
        }
      >
        {profileImageUrl ? (
          <Image
            src={profileImageUrl}
            alt={alt || 'Immagine profilo'}
            boxSize={size}
            borderRadius="12px"
            objectFit="cover"
            border="2px solid"
            borderColor="yellow.400"
          />
        ) : (
          <Image
            src={logoImg}
            alt="CIL"
            boxSize={size}
            borderRadius="12px"
            objectFit="contain"
            bg="gray.700"
            border="2px dashed"
            borderColor="gray.500"
            p={2}
          />
        )}
        <Box
          className="overlay"
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          borderRadius="12px"
          bg="blackAlpha.600"
          opacity={0}
          transition="opacity 0.2s"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Text fontSize={{ base: 'xs', md: 'sm' }} fontWeight="medium">
            Cambia immagine
          </Text>
        </Box>
      </Box>
      <Input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={onImageChange}
        position="absolute"
        opacity={0}
        w={0}
        h={0}
        overflow="hidden"
        aria-label="Carica immagine profilo"
      />
      <Box mt={2} display="flex" flexWrap="wrap" gap={2} alignItems="center">
        <Text fontSize="xs" color="gray.400">
          JPG, PNG, GIF, WebP. Max 5MB.
        </Text>
        {profileImageUrl && onRemoveImage && (
          <Button
            size="xs"
            variant="link"
            color="red.400"
            _hover={{ color: 'red.300', textDecoration: 'underline' }}
            onClick={(e) => {
              e.stopPropagation();
              onRemoveImage();
            }}
            isDisabled={uploading}
          >
            Rimuovi immagine
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ProfileImageUploader;
